module.exports = __webpack_public_path__ + "img/rightArrow.af920677.png";